import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Container.module.scss";
export const Container = ({ size = "lg", as: Tag = "div", className, children, ...rest }) => {
    const sizeClass = styles[`size${size.charAt(0).toUpperCase()}${size.slice(1)}`];
    return React.createElement(Tag, { className: cn(styles.container, sizeClass, className), ...rest }, children);
};
